/***************************************** Slidshow *****************************/

// slideshow
new Swiper("#productSwiper", {
    effect: "fade",
    loop: true,
    navigation: {
        nextEl: '#productSwiperRight',
        prevEl: '#productSwiperLeft',
    },
    pagination: {
        el: '#productSwiperPagination',
        clickable: true
    },
});